import {
  DELETE_MANY,
  CRUD_DELETE_MANY,
  DELETE,
  CRUD_DELETE,
} from "react-admin";

export const crudDeleteManyWithChecked = (
  resource,
  ids,
  checked,
  basePath,
  refresh
) => ({
  type: CRUD_DELETE_MANY,
  payload: { ids, checked },
  meta: {
    resource,
    fetch: DELETE_MANY,
    onSuccess: {
      notification: {
        body: "ra.notification.deleted",
        level: "info",
        messageArgs: {
          smart_count: ids.length,
        },
      },
      basePath,
      refresh,
      unselectAll: true,
    },
    onFailure: {
      notification: {
        body: "ra.notification.http_error",
        level: "warning",
      },
    },
  },
});

export const crudDeleteWithChecked = (
  resource,
  id,
  checked,
  basePath,
  refresh,
  redirectTo
) => ({
  type: CRUD_DELETE,
  payload: { id, checked },
  meta: {
    resource,
    fetch: DELETE,
    onSuccess: {
      notification: {
        body: "ra.notification.deleted",
        level: "info",
        messageArgs: {
          smart_count: 1,
        },
      },
      refresh,
      redirectTo,
      basePath,
    },
    onFailure: {
      notification: {
        body: "ra.notification.http_error",
        level: "warning",
      },
    },
  },
});
